import { render, staticRenderFns } from "./suningDetail.vue?vue&type=template&id=17c54668&scoped=true&"
import script from "./suningDetail.vue?vue&type=script&lang=js&"
export * from "./suningDetail.vue?vue&type=script&lang=js&"
import style0 from "./suningDetail.vue?vue&type=style&index=0&id=17c54668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c54668",
  null
  
)

export default component.exports